type SectionTitleProps = {
  children?: React.ReactNode
}

export function SectionTitle({ children }: SectionTitleProps) {
  return <div className="mb-4 mt-6 text-lg font-medium">{children}</div>
}
